import { api_url } from "../../../utils";

const LineasDeseo = {
    enable: true,
    checked: false,
    initialDisplay: true,
    excludeCities: [],
    source: "api",
    url: api_url + "maps/geojson/?table=lineas_de_deseo&schema_city=",
    zindex: 2,
    type: "graduated",
    popup: {
        default: {
            content: {
                es: {
                    total: "",
                },
            },
            separators: {
                decimal: [],
                thousand: [],
            },
        },
    },
    titleSideBar: "Mobility Indicators Content.layers.LineasDeseo",
    style: {
        regular: false,
        fillColor: "rgb(184, 164, 191)",
        strokeColor: "rgb(184, 164, 191)",
        strokeWidth: 1,
        strokeLineDash: [],
        points: 0,
        radius: 0,
        angle: 0,
        rotation: 0,
    },
    legend: {
        default: {
            title: "Mobility Indicators Content.layersLegend.LineasDeseo.title",
            subtitle: "",
            attribute: "total",
            symbol: "line",
            legendCustomCssClass: "",
            class: [
                {
                    fillColor: "rgb(184, 164, 191)",
                    strokeColor: "rgb(184, 164, 191)",
                    strokeWidth: 3,
                    min: 0,
                    max: 4999,
                    label: "Mobility Indicators Content.layersLegend.LineasDeseo.classes.1",
                    customCssClass: "",
                },
                {
                    fillColor: "rgb(184, 164, 191)",
                    strokeColor: "rgb(184, 164, 191)",
                    strokeWidth: 7,
                    min: 5000,
                    max: 19999,
                    label: "Mobility Indicators Content.layersLegend.LineasDeseo.classes.2",
                    customCssClass: "",
                },
                {
                    fillColor: "rgb(184, 164, 191)",
                    strokeColor: "rgb(184, 164, 191)",
                    strokeWidth: 11,
                    min: 20000,
                    max: 34999,
                    label: "Mobility Indicators Content.layersLegend.LineasDeseo.classes.3",
                    customCssClass: "",
                },
                {
                    fillColor: "rgb(184, 164, 191)",
                    strokeColor: "rgb(184, 164, 191)",
                    strokeWidth: 15,
                    min: 35000,
                    max: 49999,
                    label: "Mobility Indicators Content.layersLegend.LineasDeseo.classes.4",
                    customCssClass: "",
                },
                {
                    fillColor: "rgb(184, 164, 191)",
                    strokeColor: "rgb(184, 164, 191)",
                    strokeWidth: 19,
                    min: 50000,
                    max: 56000,
                    label: "Mobility Indicators Content.layersLegend.LineasDeseo.classes.5",
                    customCssClass: "",
                },
            ],
        },
    },
};

export default LineasDeseo;
